import { render, staticRenderFns } from "./business-profile.vue?vue&type=template&id=fb82161a&"
import script from "./business-profile.vue?vue&type=script&lang=js&"
export * from "./business-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports